import { useEffect, useMemo, useState } from "react";

export const useDevice = () => {
  const [isMobile, setIsMobile] = useState<boolean>(window.matchMedia("(pointer:coarse)").matches);
  const [isSmallScreen, setSmallScreen] = useState<boolean>(window.innerWidth < 1024);

  const isTouchDevice = useMemo(
    () =>
      typeof window !== "undefined" &&
      ("ontouchstart" in window || "ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0),
    []
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.matchMedia("(pointer:coarse)").matches);
      setSmallScreen(window.innerWidth < 1024);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return {
    isMobile,
    isSmallScreen,
    isTouchDevice,
  };
};
